import { ComponentProps, PropsWithChildren } from 'react'
import { cn } from '../utils'
import { ErrorIcon32 } from '../icons'

export interface ErrorAlertProps extends ComponentProps<'div'> {
  error?: Error | string | null
  'data-testid': string
}
export default function ErrorAlert({
  children,
  className,
  error,
  'data-testid': testId,
  ...props
}: PropsWithChildren<ErrorAlertProps>) {
  return (
    <div
      className={cn(
        'flex flex-col gap-0.25 text-left border-red-500 dark:border-red-400 border-2 p-1 text-cool-gray-700 dark:text-cool-gray-200',
        className
      )}
      data-testid={testId}
      {...props}
    >
      <div className="flex items-center gap-0.5" data-testid={`${testId}-div`}>
        <ErrorIcon32
          className="shrink-0 text-red-500 dark:text-red-400"
          data-testid={`${testId}-icon`}
        />
        <div data-testid={`${testId}-children-div`}>{children}</div>
      </div>
      {error && (
        <div
          className="self-end -mb-0.5 -mr-0.5 text-cool-gray-400 dark:text-cool-gray-200 text-sm"
          data-testid={`${testId}-message-div`}
        >
          <div data-testid={`${testId}-message`}>
            {error instanceof Error ? error.message : `${error}`}
          </div>
        </div>
      )}
    </div>
  )
}
